module.exports = __webpack_public_path__ + "img/6aa9e86e2ff11e31b631270528afe2d8.png";